import classNames from "@casino/external/classNames";
import useSite from "@casino/legacy/client/hooks/useSite";
import type { ReactElement } from "react";
import EmptyStateContent from "./EmptyStateContent";

type EmptyStateProps = {
  title: ReactElement;
  message?: ReactElement;
  icon?: ReactElement;
  action?: ReactElement;
};

const EmptyState: FC<EmptyStateProps> = ({ title, message, icon, action }) => {
  const { isBridgeSite } = useSite();
  return (
    <div
      className={classNames(
        "flex flex-col items-center rounded-xl bg-[#F9F7F6] p-16 lg:flex-row lg:bg-[160px_center] lg:p-10",
        isBridgeSite && "bg-secondary",
      )}
    >
      {icon && <div className="mb-10 lg:mb-0">{icon}</div>}
      <EmptyStateContent title={title} message={message} action={action} />
    </div>
  );
};

export default EmptyState;
